export default __webpack_public_path__ + "8b34fa3659ac88cb6d5b21d43ada46dc.png";